<template>
  <div class="header">
    <!-- <i class="iconStyle iconfont icon-a-2-caidan"></i> -->
    <!-- <i class="el-icon-menu"></i> -->
    <span  class="white">智付系统商户自助管理平台</span>
    <div class="logout" @click="logout">
      <i class="white el-icon-switch-button"></i>
      <span class="white" slot="title">退出登录</span>
    </div>
  </div>
</template>

<script>
import { doLogout } from '@/api/login'
import '@/assets/style/icon.css';
export default {
  name: 'Navigation',
  methods:{
    logout(){
      var that =this;
      doLogout({}).then(res=>{
        that.$message(res.msg)
        // localStorage.removeItem('Authorization');
        that.$cookies.remove('Authorization');
        that.$router.push({
        	path:'/'
        })
      }).catch(err=>{
         console.log(err)
      })

    }
  }
};
</script>

<style>
.header {
  background-color: #4387cb;
  color: #333;
  text-align: left;
  line-height: 80px;
}

.iconStyle {
  color: #fff;
  font-size: 30px;
  /* margin-right:20px ; */
}
.white {
  color: #fff;
  font-size: 26px;
}
.logout{
  float: right;
  color: #fff;
    font-size: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue